import { useState } from "react";
import {
  RequestCreateBaseRequest,
  BasesCreateBasePostRequest,
  BasesApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiRegisterBase = () => {
  const [resultRegister, setResultRegister] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const registerBase = async (req: RequestCreateBaseRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: BasesCreateBasePostRequest = {
        req,
      };

      const api = new BasesApi(config);
      const response = await api.basesCreateBasePost(request);
      setResultRegister(response);
      return response;
    } catch (err) {
      setError("拠点の登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { registerBase, resultRegister, error, isLoading };
};
